<div class="flex flex-column gap-1">
  <eo-form-label
    *ngIf="isVisible()"
    [formId]="id"
    [label]="getLabel()"
    [required]="isRequired()"
  />

  <div *ngIf="!notApplicable" class="flex justify-content-between align-items-stretch gap-2">
    <div class="flex-grow-1 max-w-full">
      <ng-content />
    </div>
    <p-button
      *ngIf="isRemovable()"
      icon="pi pi-times"
      severity="danger"
      (onClick)="onRemoveHandler()"
    />
  </div>

  <div *ngIf="canBeNotApplicable" class="w-100 flex gap-2 mt-2">
    <p-checkbox
      [(ngModel)]="notApplicable"
      [binary]="true"
      inputId="not_applicble_cb_{{ id }}"
    />
    <eo-form-label
      formId="not_applicble_cb_{{id}}"
      [label]="notApplicableLabel"
      [required]="false"
    />
  </div>

  <div class="flex flex-column gap-0">
    <eo-form-help-msg [formId]="id" [help]="getHelp()" />
    <eo-max-length-counter-msg [formControl]="getFormControl()" />
    <eo-validation-error-msg
      [formControl]="getFormControl()"
      [errors]="getErrors()"
    />
  </div>
</div>
